@if (parts && parts.length) {
<ul class="nav nav-pills" role="tablist">
  @for (item of parts; track $index) {
<li [class.active]="presentTabClicked === item">
    <a (click)="onSelectInnerTab(item)" style="cursor: pointer;" class="btn-sm">{{ item }}</a>
  </li>
}
</ul>
}

<h4 class="form-title">{{ formHeaderName || currentFormHeader?.DESCRIPTION }}</h4>

<div id="table_container">
  <table class="table table-bordered custom-table form-inline">
    <tbody>
      <tr>
        <th col width="100" style="text-align: center;">{{ tableHeader[0]?.LINE_NO || subTableHeaderSelected[0]?.LINE_NO }}</th>
        @if (!hideDescription) {
<th style="text-align: center;">{{ tableHeader[0]?.DESCRIPTION || subTableHeaderSelected[0]?.DESCRIPTION }}</th>
}
        @for (val of ((subTableHeaderSelected && subTableHeaderSelected.length) ? subTableHeaderSelected : tableHeader); track trackByLineAttribKey($index, val)) {
<th
            style="text-align: center;">
          {{ val.ATTRIB_DESCRIPTION }}
        </th>
}
      </tr>

      @for (row of rows; track trackByLineAttribKey($index, row)) {
<tr class="table1">
        @if (row.ROW_TYPE !== 'PH') {
<td>{{ row.LINE_DISP }}</td>
}
        @if (row.ROW_TYPE === 'PH') {
<td class="color-red"><b>{{ row.LINE_DISP }}</b></td>
}

        @if (!hideDescription) {

          @if (row.ROW_TYPE === 'PH') {
<td class="color-red"><b>{{ row.DESCRIPTION }}</b></td>
}
          @if (row.ROW_TYPE !== 'PH') {
<td [innerHTML]="row.DESCRIPTION"></td>
}
        
}

        <!-- Regular cells (not DTA, not radio) -->
        @if (row.ROW_TYPE !== 'DTA') {

          @for (row1 of getNonRadioCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<td
              [style.width]="isEntry ? '220px' : '220px'"
              [style.text-align]="isEntry ? 'center' : null">
            @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'radio') {
<div
                 style="text-align: right; padding-right: 10px;"
                 [class.color-red]="row1.ATTRIB_VALUE < 0">
              <span>{{ row1.ATTRIB_VALUE }}</span>
            </div>
}
            @if (row1.IS_EDITABLE_CELL === 'Y'
                       && row1.EDIT_TYPE !== 'checkbox'
                       && row1.EDIT_TYPE !== 'radio'
                       && row1.EDIT_TYPE !== 'custom_date_various'
                       && row1.EDIT_TYPE !== 'dropdown') {
<div
                 [style.text-align]="isEntry ? 'center' : 'right'"
                 style="padding-right: 10px;">
              @if (row1.DATA_TYPE === 'number') {
<input
                     class="form-control input-md numText"
                     style="text-align: right" type="text"
                     [ngModel]="row1.ATTRIB_VALUE"
                     (ngModelChange)="onTextChange(row1, $event)">
}
              @if (row1.DATA_TYPE === 'string') {
<input
                     class="form-control input-md numText"
                     style="text-align: right" type="text"
                     [ngModel]="row1.ATTRIB_VALUE"
                     (ngModelChange)="onTextChange(row1, $event)">
}
            </div>
}
            @if (row1.EDIT_TYPE === 'checkbox') {
<div style="padding-left: 25px;">
              <label>
                <input type="checkbox"
                       [checked]="row1.ATTRIB_VALUE === 'true'"
                       (change)="onCheckboxInputChange(row1, $event)">
                {{ row1.ATTRIB_DESCRIPTION }}
              </label>
            </div>
}
            @if (row1.EDIT_TYPE === 'dropdown') {
<div style="padding-left: 25px;">
              <select class="form-control"
                      style="width: 200px"
                      [ngModel]="row1.ATTRIB_VALUE"
                      (ngModelChange)="onDropdownInputChange(row1, $event)">
                <option value="">Select</option>
                @for (s of formLOV; track $index) {
<option [value]="s.CODE_NAME">{{ s.CODE_DESC }}</option>
}
              </select>
            </div>
}
            @if (row1.EDIT_TYPE === 'custom_date_various') {
<div style="padding-left: 25px;">
              <gtw-credits-date-various
                [row]="row1"
                (changed)="onDateVariousChangeIn(row1)">
              </gtw-credits-date-various>
            </div>
}
          </td>
}
        
}

        <!-- DTA cells with radio inside -->
        @if (row.ROW_TYPE === 'DTA') {

          <td style="width: 220px;">
            @for (row1 of getDTACells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div>
              @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'radio') {
<div
                   style="text-align: right; padding-right: 10px;"
                   [class.color-red]="row1.ATTRIB_VALUE < 0">
                <span>{{ row1.ATTRIB_VALUE }}</span>
              </div>
}
              @if (row1.IS_EDITABLE_CELL === 'Y'
                          && row1.EDIT_TYPE !== 'checkbox'
                          && row1.EDIT_TYPE !== 'radio'
                          && row1.EDIT_TYPE !== 'custom_date_various'
                          && row1.EDIT_TYPE !== 'dropdown') {
<div
                   style="text-align: right; padding-right: 10px;">
                @if (row1.DATA_TYPE === 'number') {
<input
                       class="form-control input-md numText"
                       style="text-align: right" type="text"
                       [ngModel]="row1.ATTRIB_VALUE"
                       (ngModelChange)="onTextChange(row1, $event)">
}
                @if (row1.DATA_TYPE === 'string') {
<input
                       class="form-control input-md numText"
                       style="text-align: right" type="text"
                       [ngModel]="row1.ATTRIB_VALUE"
                       (ngModelChange)="onTextChange(row1, $event)">
}
              </div>
}
              @if (row1.EDIT_TYPE === 'radio') {
<div style="padding-left: 25px;">
                <label>
                  <input type="checkbox"
                         [checked]="row1.ATTRIB_VALUE === 'true'"
                         (change)="onCheckBox8941(row1)">
                  {{ row1.ATTRIB_DESCRIPTION }}
                </label>
              </div>
}
            </div>
}
          </td>
        
}

        <!-- Single radio column (not DTA, not F8936) -->
        @if (row.EDIT_TYPE === 'radio' && row.ROW_TYPE !== 'DTA') {
<td
            style="width: 183px; text-align: left; padding-right: 10px;">
          @for (row1 of getRadioCells(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div>
            <label>
              <input type="checkbox"
                     [checked]="row1.ATTRIB_VALUE === 'true'"
                     (change)="onCheckBox8941(row1)">
              {{ row1.ATTRIB_DESCRIPTION }}
            </label>
          </div>
}
        </td>
}
      </tr>
}
    </tbody>
  </table>
</div>
